// extracted by mini-css-extract-plugin
export default {"icon":"SpeakerLinkedSponsorIcon-module-a4b0d01a793f9ad6871e"};